import React from "react";
import data from "../../data/blog/forthwroth.json";

function navigation() {
  const blogData = data[2];

  return (
    <div className="max-w-5xl px-4 mx-auto">
      {blogData.Mainheading.map((item, index) => (
        <div key={index} className="">
          {/* Title */}
          <h2 id={item.id} className="blogtitle">
            {item.title}
          </h2>
          <p className="blogcontent">{item.content}</p>

  
          {item.terminal && <p id={item.id} className="blogSubtitle">{item.terminal}</p>}
          {item.content1 && <p className="blogcontent">{item.content1}</p>}
          {item.content2 && <p className="blogcontent">{item.content2}</p>}
          
          {/* Image */}
          {item.image && (
            <img
              src={item.image}
              alt={item.title}
              className=" rounded-lg mb-4"
            />
          )}

          <div className="">
          {item.heading && <p id={item.id} className="blogh4">{item.heading}</p>}
          {item.content3 && <p className="blogcontent">{item.content3}</p>}
          </div>
        </div>
      ))}
    </div>
  );
}

export default navigation;
